module.exports = __webpack_public_path__ + "static/doss_lute-a8d6a3fd33cf70dad2646ab39b7cfd40.jpg";